/**
 * @description generate one random string with length
 * @param length
 */
export function randString(length = 10) {
    const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz';
    let result = '';
    for (let i = 0, rnum; i < length; ++i) {
        rnum = Math.floor(Math.random() * chars.length);
        result += chars.charAt(rnum);
    }
    return result;
}
;
export function getSecond() {
    return Math.floor(Date.now() / 1e3);
}
